import React, { useState } from "react";
import {useNavigate} from "react-router-dom"
import {toast} from "react-hot-toast"
function ForgotPasswordFlow() {


  const apiUrl= process.env.REACT_APP_API_URL

  const auth = process.env.REACT_APP_REV_KEY

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(null);

  const [email, setEmail] = useState("");

  const [password, setpassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");

  const [otp, setOtp] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "otp":
        setOtp(value);
        break;
      case "password":
        setpassword(value);
        break;
      case "cnfPassword":
        setCnfPassword(value);
        break;
      default:
        break;
    }
  };

  const requestOtp = async () => {

    if(!email){
      toast.error("User Id is Required");
      return;
    }

    setLoading(true)

    try {
      const res = await fetch(`${apiUrl}/auth/admin/forgotuserpassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "seckey":auth
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

    
   
      
      if (res.ok) {
        setStep("verify");
           toast.success(data.message)
      }else(
        toast.error(data.message)
      )
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  };

  const verifyOtpRequest = async() => {

    
    setLoading(true)

    try {
      const res = await fetch(`${apiUrl}/auth/admin/forgot-password-verifyed`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
             "seckey":auth
        },
        body: JSON.stringify({ email ,otp }),
      });

      const data = await res.json()   
      if (res.ok) {
        setStep("updatePassword");
           toast.success(data.message)
      }else(
        toast.error(data.message)
      )
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }  ;




  const navigate = useNavigate()

  const UpdatePassport = async() => {


    
    setLoading(true)

    try {
      const res = await fetch(`${apiUrl}/auth/admin/update-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
             "seckey":auth
        },
        body: JSON.stringify({ email , password,cnfPassword }),
      });

      const data = await res.json();

      console.log("Forgot Api",data)
   
      if (res.ok) {
         toast.success(data.message)
         navigate("/")

      }else(
        toast.error(data.message)
      )
    } catch (error) {
      console.log(error);
    }
    setLoading(false)



  };

  return (
    <div>
      <div className="for-got-password-container">
        <div className="for-got-password-container-main">
          <div className="for-got-password-form-container">
            <h4>Forgot Password</h4>

            <div className="forgot-password-input-row">
              <input
                placeholder="Enter Email"
                name="email"
                value={email}
                onChange={handleChange}
              />
            </div>



{

  step === "verify" &&(
            <div className="forgot-password-input-row">
              <input
                placeholder="Enter Otp"
                name="otp"
                value={otp}
                onChange={handleChange}
              />
            </div>

  )
}


{
  step === "updatePassword" &&(

<>
            <div className="forgot-password-input-row">
              <input
                placeholder="New Password"
                name="password"
                value={password}
                onChange={handleChange}
              />
            </div>

            <div className="forgot-password-input-row">
              <input
                placeholder="Conform Password"
                name="cnfPassword"
                value={cnfPassword}
                onChange={handleChange}
              />
            </div>

            </>
  )
}


{

  step === null ? (

     <div className="for-got-otp-request-btn">
      {
        loading ?
        <div>Verifying...</div>
        :
        <button onClick={() => requestOtp()}>Request Otp</button>
      }
              <div></div>
            </div>
    


  ) : step === "verify" ?(

         <div className="for-got-otp-request-btn">
          {
            loading ?
                <div>Verifying...</div>

            :
              <button onClick={() => verifyOtpRequest()}>Verify Otp</button>
          }
            </div>

  ):step === "updatePassword"  ?(
            <div className="for-got-otp-request-btn">

              {
                loading ?
                <div>Updating...</div>

                :
              <button onClick={() => UpdatePassport()}>Submit</button>
              }
            </div>

  ):"Something is wrong. Please try again"
}



          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordFlow;
